import type { FaireProductEntity } from "../../entity_types/product";

export const p_cr98ruj8gv: FaireProductEntity = {
  token: "p_cr98ruj8gv",
  type: "product",
  name: "A Collection of Stories for 1-Year-Olds Board Book",
  brandToken: "b_75qtacjqim",
  brandName: "Cottage Door Press",
  imageUrl:
    "https://cdn.faire.com/fastly/bf081c49ade28a93eb93486fca58c839a6c3468655c65ef583c40f74e13deb25.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/12558ddedf9341d061f87faeabef4de7de159b395da217e0f5b718279008c713.jpeg",
    "https://cdn.faire.com/fastly/8e0192fd817e047c700fafae973518e4b1d368bc20c1d36cd45df129ec078f9a.jpeg",
    "https://cdn.faire.com/fastly/c75be58c52958295c0d395d7bc506074c6b9a6d08f6368d60195836ba8532df5.jpeg",
    "https://cdn.faire.com/fastly/3e949e5ec099072d7fafc158db0f76a0345df94507e2f0d4cb02c80b0df7fb08.jpeg",
    "https://cdn.faire.com/fastly/9b1ff1bcbc689ea6d568a9858f5f13655baf15f0d6479d774e89035fb854df7c.png",
  ],
  priceDollars: 4.67,
  description:
    "Snuggle up with your baby boy or girl and share stories and nursery rhymes from this beautiful, padded board book with your toddler. Carefully chosen for 1-year-olds, they are easy to read with enchanting illustrations filling every page of the book. Enjoy the tales of The Little Red Hen and Five Little Ducks, or the sweet nursery rhymes, Itsy Bitsy Spider and Hey Diddle Diddle in a sturdy, collectible format with a fun cut-out cover.\n\nShort, easy-to-read stories ideal for capturing the attention of preschoolers\nPlayful illustrations fill every page - perfect for keeping babies and toddlers entertained and engaged\nIncludes 10 classic, popular stories and rhymes designed to delight your little one during story time\nWonderful gift for any occasion: birthdays, baby showers, newborns, holidays, Christmas, and more\nCollect the entire series with books for every milestone—perfect gifts for children ages 1-5",
  tags: [],
  msrpDollars: 8.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:35.413Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
